import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Meta, SafeUrl, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import {
  ContactFormComponent,
  ExternalLinksComponent,
  TextComponent,
} from '@out-web/components';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-contact',
  standalone: true,
  imports: [
    CommonModule,
    ExternalLinksComponent,
    ContactFormComponent,
    TextComponent,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent implements OnInit {
  safeMailtoUrl: SafeUrl;
  constructor(
    private seoService: SeoService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    const mailtoUrl = 'mailto:contact@onlyusedtesla.com';
    this.safeMailtoUrl = this.sanitizer.bypassSecurityTrustUrl(mailtoUrl);
  }
  isSubmitted = false;
  ngOnInit(): void {
    this.setMetaData();
    this.routeEvent();
  }

  private setMetaData() {
    const title = 'Contact | Sell Your Tesla | Only Used Tesla';
    const description = 'Get in touch with us to sell your Tesla or inquire about our marketplace services. Only Used Tesla offers a seamless selling experience.';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png'; // You can change this image if needed
    const url = 'https://onlyusedtesla.com/contact';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }

  private routeEvent() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url === '/contact') {
        this.isSubmitted = false;
      }
    });
  }

  handleSuccess() {
    this.isSubmitted = true;
    this.router.navigate(['/contact/enquiry-submitted']);
  }
}
